import { Navbar, Nav, Container, NavDropdown, Badge } from 'react-bootstrap';
import { FaShoppingCart, FaUser } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import SearchBox from './SearchBox';
import logo from '../assets/logo.png';
import { resetCart } from '../slices/cartSlice';

const Header = () => {
  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth); // isAdmin and isStaff flags come from backend

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(resetCart());
      navigate('/login');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <header>
      <Navbar bg='primary' variant='dark' expand='lg' collapseOnSelect>
        <Container>
          <Navbar.Brand as={Link} to='/'>
            <img src={logo} alt='P' />
            roperties
          </Navbar.Brand>
          <Navbar.Brand as={Link} to='/house/HomeScreen'>Market</Navbar.Brand>
          <Navbar.Brand as={Link} to='/services'>Services</Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ms-auto'>
              <SearchBox />
              <Nav.Link as={Link} to='/cart'>
                <FaShoppingCart /> Cart
                {cartItems.length > 0 && (
                  <Badge pill bg='success' style={{ marginLeft: '5px' }}>
                    {cartItems.reduce((a, c) => a + c.qty, 0)}
                  </Badge>
                )}
              </Nav.Link>

              {/* Authenticated User */}
              {userInfo ? (
                <>
                  {/* User Dropdown */}
                  <NavDropdown title={userInfo.name} id='username'>
                    <NavDropdown.Item as={Link} to='/profile'>Profile</NavDropdown.Item>
                    <NavDropdown.Item onClick={logoutHandler}>Logout</NavDropdown.Item>
                  </NavDropdown>

                  {/* Admin Links */}
                  {userInfo.isAdmin && ( // Check if isAdmin is true
                    <NavDropdown title='Admin' id='adminmenu'>
                      <NavDropdown.Item as={Link} to='/cartform'>Forms</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/adminform'>AdminPages</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/orderlist'>Orders</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/userlist'>Users</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/houselist'>Houses</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/productlist'>Itemlist</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/expenselist'>Nafulo</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/adminuserprofile'>ResetPassword</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/adminuserscreen'>ChangeUserRole</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stockreport'>Creditsale</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stockanalysis'>StockAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/balance'>CashAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/alltotal'>Total Cashflow</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/notelist'>AdminNote</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/depositlist'>Bank</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stockuniquedates'>StockDates</NavDropdown.Item>
                    </NavDropdown>
                  )}

                  {/* Staff Links */}
                  {userInfo.isStaff && ( // Check if isStaff is true
                    <NavDropdown title='Staff' id='staffmenu'>
                      <NavDropdown.Item as={Link} to='/cartform'>Forms/Pages</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffsale'>Sales</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffsupply'>Supplies</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stafftransfer'>Transfers</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffstock'>Stock</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffopeningstock'>OP Stock</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stockuniquedates'>StockDates</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffnote'>Notes</NavDropdown.Item>
                      
                      <NavDropdown.Item as={Link} to='/usestockanalysis'>StockAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/balance'>CashAnalysis</NavDropdown.Item>
                      {/* Add more staff-specific links as needed */}
                    </NavDropdown>
                  )}
                </>
              ) : (
                <Nav.Link as={Link} to='/login'>
                  <FaUser /> Sign In
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;